// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"style_tableStyle__2OgI1"};